import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SummaryGridSectionComponent } from "./components/summary-grid-section/summary-grid-section.component";
import { SummaryGridTileComponent } from "./components/summary-grid-tile/summary-grid-tile.component";
import { TranslationPipeModule } from "@modules/core/pipes/translation-pipe/translation-pipe.module";
import { SummaryAmountTileComponent } from "@modules/+new/payments/shared-payments/components/summary-grid/components/summary-amount-tile/summary-amount-tile.component";
import { SummaryProviderTileComponent } from "@modules/+new/payments/shared-payments/components/summary-grid/components/summary-provider-tile/summary-provider-tile.component";
import { SummaryWalletTileComponent } from "@modules/+new/payments/shared-payments/components/summary-grid/components/summary-wallet-tile/summary-wallet-tile.component";
import { FiatPrecisionPipeModule } from "@modules/+new/shared/fiat-precision-pipe/fiat-precision-pipe.module";

@NgModule({
	declarations: [
		SummaryGridSectionComponent,
		SummaryGridTileComponent,
		SummaryAmountTileComponent,
		SummaryProviderTileComponent,
		SummaryWalletTileComponent
	],
	imports: [CommonModule, TranslationPipeModule, FiatPrecisionPipeModule],
	exports: [SummaryGridSectionComponent, SummaryGridTileComponent]
})
export class SummaryGridModule {}
